// GTranslateWidget.jsx
import React, { useEffect } from "react";

const GTranslateWidget = () => {
  useEffect(() => {
    // Inject gtranslate settings first
    const scriptSettings = document.createElement("script");
    scriptSettings.innerHTML = `
      window.gtranslateSettings = {
        default_language: "en",
        native_language_names: true,
        detect_browser_language: true,
        languages: ["en", "fi", "sv"],
        wrapper_selector: ".gtranslate_wrapper",
        flag_size: 32,
        horizontal_position: "left",
        vertical_position: "bottom"
      };
    `;
    document.body.appendChild(scriptSettings);

    // Load the GTranslate script
    const script = document.createElement("script");
    script.src = "https://cdn.gtranslate.net/widgets/latest/flags.js";
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Clean up when unmounting
      document.body.removeChild(script);
      document.body.removeChild(scriptSettings);
    };
  }, []);

  return <div className="gtranslate_wrapper"></div>;
};

export default GTranslateWidget;
